"use client";

export default function VersionBadge() {
  const version = process.env.NEXT_PUBLIC_APP_VERSION;
  const isDev = process.env.NODE_ENV === "development";

  if (!version || !isDev) return null;

  return (
    <div className="fixed bottom-2 right-2 z-50 px-2 py-1 text-xs text-gray-500 bg-white/70 backdrop-blur-sm rounded shadow-sm">
      v{version}
    </div>
  );
}
